import { useState, useEffect } from 'react';

interface User {
  uid: string;
  displayName: string | null;
  email: string | null;
  photoURL: string | null;
  // Add other user properties as needed
}

export const useUser = () => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // In a real app, you would subscribe to an auth state change
    // For now, we'll simulate a logged-in user
    const timer = setTimeout(() => {
      setUser({
        uid: '123',
        displayName: 'Demo User',
        email: 'demo@example.com',
        photoURL: null
      });
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return { user, loading };
};
